/**
* @Author: zachalam
* @Date:   2017-01-16T16:36:08-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T14:07:27-07:00
*/

import React, { Component } from 'react';
import glamorous from 'glamorous';
import { StyleSheet } from 'aphrodite/no-important';

import MediaQuery from 'react-responsive';
import LoadingMsg from '../../common/LoadingMsg';

/* Profile Actions Bar */
import UserActions from './UserActions';
import ProfileActions from './ProfileActions';

/* sidebar components */
import MainPhoto from './MainPhoto';
import MoreInfo from './MoreInfo';
import InterestedIn from './InterestedIn';

/* right side bar components */
import UserDetails from './UserDetails';
import PersonalInfo from './PersonalInfo';
import DetailsTab from './DetailsTab';
import ProfileTabs from './ProfileTabs';
import Container from '../../blocks/Container';
import ProfileTrips from './ProfileTrips';
import Photos from './Photos';

import Title from '../../common/Title';
import { dimensions, spacing, borders } from '../../../style'
import PhotoLightbox from '../Photos/PhotoLightbox';

const style = StyleSheet.create({
  container: {
    [dimensions.SCREEN_MIN_MD]: {
      padding: '0 40px'
    }
  },

  hero: {
    [dimensions.SCREEN_MIN_SM]: {
      display: 'flex'
    }
  },
  /**
   * Main area below Hero section
   */
  body: {
    position: 'relative'
  }
})

const PageDiv = glamorous.div({
  backgroundColor: '#FAFAFA'
});

const HeroContainer = glamorous.main({
  backgroundColor: '#FFF',
  marginBottom: '20px',
  padding: '20px 0',
  paddingBottom: '45px',
  borderBottom: borders.DEFAULT
});

const ImageDiv = glamorous.div({
  marginRight: '22px',
  marginLeft: '-20px',
  width: '140px',
  height: '140px',

  [dimensions.SCREEN_MAX_MD]: {
    alignSelf: 'center',
    marginLeft: '0',
    width: '120px',
    height: '120px'
  },

  [dimensions.SCREEN_MAX_SM]: {
    margin: '0 auto',
  }
});

const InfoSection = glamorous.section({
  display: 'flex',
  flexGrow: '1',
  alignItems: 'center',
  justifyContent: 'space-between',

  [dimensions.SCREEN_MAX_MD]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'initial',
  },
  [dimensions.SCREEN_MAX_SM]: {
    textAlign: 'center'
  }
});

const ActionDiv = glamorous.div({
  [dimensions.SCREEN_MAX_MD]: {
    padding: '10px 0'
  }
});

const MainContainer = glamorous.div({
  display: 'flex',
  flexFlow: 'row-reverse nowrap',
  flex: '1',
  [dimensions.SCREEN_MAX_MD]: {
    display: 'block'
  }
});

const ContentAside = glamorous.div({
  [dimensions.SCREEN_MIN_SM]: {
    flex: '0 0 320px',
    marginLeft: '32px'
  }
});

const ContentMain = glamorous.div({
  flexGrow: 1
});

class Profile extends Component {
  state = {
    ignored: false,
    isLightboxOpen: false,
    currentImage: 0,
    allowZoom: false
  };
  
  openLightbox = (index, event) => {
    console.log(index);
    this.setState({
      currentImage: index,
      isLightboxOpen: true,
    });
  };

  lightboxOnClose = () => {
    this.setState({isLightboxOpen: false });
  };

  render() {

    if(this.props.profile.profile) {
      let account = this.props.profile;
      let profile = account.profile.data;
      let myprofile = this.props.myprofile;
      let photoList = Object.keys(this.props.profile.photo.data).map((key) => {
        let photo = this.props.profile.photo.data[key];
        return {
          src: photo.urls.resized,
          thumbnail: photo.urls.profile
        };

      });

      return (
        <PageDiv>
          <HeroContainer>
            <Container styles={[style.hero, style.container]}>
              <ImageDiv>
                <MainPhoto
                  avatar={profile.avatar.data.urls.profile}
                  onClick={this.openLightbox}
                />
              </ImageDiv>
              <InfoSection>
                <UserDetails username={this.props.profile.username} profile={profile} />
                <ActionDiv>
                  {myprofile.username === account.username ? <UserActions /> :
                    <ProfileActions username={account.username}
                      isFavorite={account.is_favorite}
                      toggleFav={this.props.toggleFav}
                      isBlocked={account.is_blocked}
                      toggleBlock={this.props.toggleBlock}
                      isApproved={myprofile.is_approved}
                      canMsg={myprofile.can_message}
                      threadExists={account.thread_exists} />}
                </ActionDiv>
              </InfoSection>
            </Container>
          </HeroContainer>
          <Container styles={[style.container, style.body]}>
            <MainContainer>
              <MediaQuery query='(min-width: 769px)'>
                <ContentAside>
                  <PersonalInfo profile={profile} />
                  <MoreInfo profile={profile} />
                  <InterestedIn profile={profile} />
                </ContentAside>
              </MediaQuery>
              <ContentMain>
                {photoList &&
                  <Photos
                    photos={photoList}
                    openLightbox={this.openLightbox}
                  />
                }
                <MediaQuery query='(max-width: 768px)'>
                  <PersonalInfo profile={profile} />
                  <MoreInfo profile={profile} />
                  <InterestedIn profile={profile} />
                </MediaQuery>
                <DetailsTab  description={profile.description} seeking={profile.seeking} />
                <ProfileTrips
                  accountId={myprofile.id}
                  trips={this.props.profile.trip.data}
                  joinTrip={this.props.joinTrip}
                />
              </ContentMain>
            </MainContainer>


          </Container>
            <PhotoLightbox
              images={photoList}
              allowZoom={this.state.allowZoom}
              lightboxIsOpen={this.state.isLightboxOpen}
              currentImage={this.state.currentImage}
              onClose={this.lightboxOnClose}
            />
        </PageDiv>
      );

    } else {
      // profile loading..
      return (<LoadingMsg msg='Loading Profile'/>);
    }
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/Profile.jsx